import { useEffect } from 'react';
import { loadUserLimits, UserStore } from 'stores/user';
import { AppContextStore, toggleSettingsMenuOpen } from 'stores/app-context';
import { SettingsMenuModal } from './settings-menu-modal';

import './settings.css';

const Settings = ({ children, setTheme }) => {
  const userInitials = UserStore.useState((s) => s.userInfo?.initials);
  const isSidebarCollapsed = AppContextStore.useState(
    (s) => s.isSidebarCollapsed,
  );
  const isSettingsMenuOpen = AppContextStore.useState(
    (s) => s.isSettingsMenuOpen,
  );

  useEffect(() => {
    if (isSettingsMenuOpen) {
      loadUserLimits();
    }
  }, [isSettingsMenuOpen]);

  return (
    <div
      className={`settings ${isSidebarCollapsed ? '-collapsed-sidebar' : ''}`}
      data-testid="settings"
    >
      {children}

      <button
        data-testid="settings-menu-button"
        className="avatar"
        aria-label="View Settings"
        onClick={toggleSettingsMenuOpen}
      >
        {userInitials}
      </button>

      <SettingsMenuModal
        toggleSettingsMenu={isSettingsMenuOpen}
        setToggleSettingsMenu={toggleSettingsMenuOpen}
        setTheme={setTheme}
      />
    </div>
  );
};

export default Settings;
